import { useState, useRef } from "react";

export default function useVideo() {
    const videoRef = useRef();
    const [isPlaying, setIsPlaying] = useState(false);
    const [videoStarted, setVideoStarted] = useState(false);

    function onPause() {
        setIsPlaying(false);
    }

    function onPlay() {
        if (!videoStarted) {
            setVideoStarted(true)
        }

        setIsPlaying(true);
    }

    return {
        ref: videoRef,
        videoStarted,
        setVideoStarted,
        isPlaying,
        eventHandler: {
            onPause,
            onPlay
        }
    };
}
